import React from 'react';
import styled from 'styled-components';
import ICellProps from '../ICellProps';
import { MaskedTextField } from 'office-ui-fabric-react/lib/TextField';
import {
  convertMinutesToTime,
  convertTextToMinutes,
} from '../../../../../../utils';

interface IProps extends ICellProps {
  onChange: (value: string | null) => void;
  readonly: boolean;
}

const TextInput = styled(MaskedTextField)`
  .ms-TextField-fieldGroup {
    border: none;
  }
`;

const TimeMinutes: React.FC<IProps> = (props: IProps) => {
  const txt = convertMinutesToTime(props.value);
  return (
    <TextInput
      value={txt}
      mask="99:99"
      onChange={(__e, newValue) => {
        const res = convertTextToMinutes(newValue);
        props.onChange && props.onChange(res !== null ? res + '' : null);
      }}
      readOnly={props.readonly}
    />
  );
};

export default TimeMinutes;
